<template>
  <div>
    <v-edit-dialog
      :return-value.sync="selectedDateTime"
      persistent
      large
      @open="open"
      @save="save"
    >
      <v-layout row justify-center align-center>
        <v-icon>schedule</v-icon>
        <div>{{ formattedDateTime }}</div>
      </v-layout>
      <template v-slot:input>
        <v-date-picker
          v-model="date"
          locale="ru"
          :first-day-of-week="1"
        ></v-date-picker>
        <v-time-picker
          v-model="time"
          format="24hr"
          class="ml-12"
        ></v-time-picker>
      </template>
    </v-edit-dialog>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { logState } from "../../classes/logging";

/*
В свойство value передается дата и время в формате ISO 8601.
Событие input компонента возвращает дату и время в том же формате.
(Таким образом реализуется связь через v-model компонента).
TODO: в перспективе работать с часовыми поясами сервера и клиента

selectedDateTime - данные для компонент Vuetify (тип Date)
тогда как fieldValue - данные entity (тип строка)
(В момент выбора при неустановленной раньше даты и времени они могут отличаться
по фактическому значению, т.к. selectedDateTime инициализируется текущей датой,
в то время как fieldValue не меняется до момента нажатия на Save).

При выборе даты или времени запускаются соответствующие сеттеры и дата пишется
в selectedDateTime (тип Date).
Получение соответсвующих величин для компонент Vuetify в виде строки происходит
в соответствующих геттерах.
Вычисляемое значение formattedDateTime возвращает отображаемое после выбора
даты и времени значение.
 */
export default {
  name: "DateTimePickerField",
  data() {
    return {
      fieldValue: "",
      selectedDateTime: null
    };
  },
  mounted() {
    this.fieldValue = this.value;
  },
  computed: {
    date: {
      get() {
        return moment(this.selectedDateTime).format("YYYY-MM-DD");
      },
      set(v) {
        logState(
          "[enter] DateTimeField.date.set(value) value =",
          { color: "blue" },
          v,
          "selectedDateTime =",
          this.selectedDateTime
        );
        let date = moment(v, "YYYY-MM-DD");
        const hour = this.selectedDateTime
          ? moment(this.selectedDateTime).hour()
          : 0;
        const minute = this.selectedDateTime
          ? moment(this.selectedDateTime).minute()
          : 0;
        date = date.hour(hour).minute(minute);
        this.selectedDateTime = date.toDate();
        logState(
          "[exit] DateTimeField.date.set(value) new selectedDateTime =",
          { color: "blue" },
          this.selectedDateTime
        );
      }
    },
    time: {
      get() {
        return moment(this.selectedDateTime).format("HH:mm");
      },
      set(v) {
        logState(
          "[enter] DateTimeField.time.set(value) value =",
          { color: "darkgreen" },
          v,
          "selectedDateTime =",
          this.selectedDateTime
        );
        const time = moment(v, "HH:mm");
        const result = moment(this.selectedDateTime)
          .hour(time.hour())
          .minute(time.minute())
          .second(0);
        this.selectedDateTime = result.toDate();
        logState(
          "[exit] DateTimeField.time.set(value) new selectedDateTime =",
          { color: "darkgreen" },
          this.selectedDateTime
        );
      }
    },
    formattedDateTime() {
      if (!this.fieldValue) return "";
      const date = new Date(this.fieldValue);
      return moment(date).format("DD.MM.YYYY HH:mm");
    }
  },
  props: ["field", "value"],
  methods: {
    open() {
      logState(
        "[enter]DateTimeField.open() fieldValue =",
        { color: "orange" },
        this.fieldValue
      );
      if (this.fieldValue) this.selectedDateTime = new Date(this.fieldValue);
      else this.selectedDateTime = new Date();
      logState(
        "[exit]DateTimeField.open() selectedDateTime =",
        { color: "orange" },
        this.selectedDateTime
      );
    },

    save() {
      logState(
        "[enter]DateTimeField.save() selectedDateTime =",
        { color: "green" },
        this.selectedDateTime
      );
      this.fieldValue = moment(this.selectedDateTime).toISOString();
      this.$emit("input", this.fieldValue);
      logState(
        "[exit]DateTimeField.save() fieldValue =",
        { color: "green" },
        this.fieldValue
      );
    }
  }
};
</script>

<style scoped></style>
